import {
  ENERGY_PERFORMANCE_WIDGET, ENERGY_PRODUCTION_WIDGET, ENERGY_RANKING_WIDGET, ENERGY_REWARDS_WIDGET,
} from 'consts';

export const mobileTitlePlugin = (ctx, chartArea, leftTitle, rightTitle) => {
  const {
    top: topCanvas,
    left: leftCanvas,
    right: rightCanvas,
  } = chartArea ?? {};
  ctx.save();
  ctx.font = '14px';
  ctx.fillStyle = '#65748f';
  if (leftTitle) {
    ctx.fillText(leftTitle, leftCanvas - 13, topCanvas - 15);
  }
  if (rightTitle) {
    ctx.fillText(rightTitle, rightCanvas - 5, topCanvas - 15);
  }
  ctx.restore();
};

export const titlePluginRewards = {
  id: 'titlePluginRewards',
  afterDatasetDraw: (chart) => {
    if (chart.canvas.id !== ENERGY_REWARDS_WIDGET) {
      return;
    }
    const { ctx, chartArea } = chart;
    mobileTitlePlugin(ctx, chartArea, '€');
  },
};

export const titlePluginPerformance = {
  id: 'titlePluginPerformance',
  afterDatasetDraw: (chart) => {
    if (chart.canvas.id !== ENERGY_PERFORMANCE_WIDGET) {
      return;
    }
    const { ctx, chartArea } = chart;
    mobileTitlePlugin(ctx, chartArea, '%');
  },
};

export const dashedBorderPlugin = {
  id: 'dashedBorderPlugin',
  afterDatasetDraw: (chart, args) => {
    if (chart.canvas.id !== ENERGY_PRODUCTION_WIDGET) {
      return;
    }
    const { ctx, chartArea } = chart;
    mobileTitlePlugin(ctx, chartArea, 'kWh', '%');
    args.meta.data.forEach((element, index) => {
      const newElement = {
        ...element,
        // eslint-disable-next-line no-underscore-dangle
        ...args?.meta?._dataset?.data[index],
      };
      if (newElement.y === 0 || newElement.y === null) {
        return;
      }
      const dash = newElement.intervalDataOrigin === 'ESTIMATED' ? [5, 5] : [];
      const borderWidth = 2;
      const props = element.getProps(['base', 'x', 'y', 'width', 'height']);
      const half = props.width / 2;
      const left = props.x - half;
      const right = props.x + half;
      const top = props.y;
      const width = right - left;
      const height = chart.chartArea.bottom - top + borderWidth / 2 - 1;
      ctx.beginPath();
      ctx.lineWidth = borderWidth;
      ctx.strokeStyle = props.options.borderColor;
      ctx.setLineDash(dash);
      ctx.moveTo(left, top);
      ctx.lineTo(left, top + height);
      ctx.moveTo(left, top);
      ctx.lineTo(left + width, top);
      ctx.moveTo(left + width, top);
      ctx.lineTo(left + width, top + height);
      ctx.stroke();
      ctx.save();
    });
  },
};

export const segmentStyle = {
  borderDash: (ctx) => {
    const { intervalDataOrigin } = ctx.p0.raw;
    const { intervalDataOrigin: intervalDataOrigin1 } = ctx.p1.raw;
    return intervalDataOrigin === 'ESTIMATED' && intervalDataOrigin1 === 'ESTIMATED' ? [5, 5] : [];
  },
  borderWidth: (ctx) => {
    const { intervalDataOrigin } = ctx.p0.raw;
    const { intervalDataOrigin: intervalDataOrigin1 } = ctx.p1.raw;
    return intervalDataOrigin === 'CERTIFIED' && intervalDataOrigin1 === 'CERTIFIED' ? 5 : 1;
  },
};

function createDiagonalPattern(color = 'black') {
  // create a 10x10 px canvas for the pattern's base shape
  const shape = document.createElement('canvas');
  shape.width = 10;
  shape.height = 10;
  // get the context for drawing
  const c = shape.getContext('2d');
  // draw 1st line of the shape
  c.strokeStyle = `rgba(${color}, 1)`;
  c.lineWidth = 2; // Imposta la larghezza della linea
  c.beginPath();
  c.moveTo(0, 10); // Parte dall'angolo in basso a sinistra
  c.lineTo(10, 0); // Va fino all'angolo in alto a destra
  c.stroke();
  // create the pattern from the shape
  return c.createPattern(shape, 'repeat');
}

export const getBarColor = (arr, color) => {
  const toRet = [];
  if (Array.isArray(arr)) {
    arr.forEach((elem) => {
      if (elem.intervalDataOrigin === 'MEASURED') {
        toRet.push(createDiagonalPattern(color));
        // TODO: bordo dello stesso colore
      } else if (elem.intervalDataOrigin === 'ESTIMATED') {
        toRet.push(`rgba(${color}, 0.3)`);
      } else {
        toRet.push(`rgba(${color}, 1)`);
      }
    });
  }
  return toRet;
};

export const customRankingPlugin = {
  id: 'custom-background',
  beforeDraw: (chart, _easing) => {
    if (chart.canvas.id !== ENERGY_RANKING_WIDGET) {
      return;
    }

    const ctx = chart.canvas.getContext('2d');
    const colors = []; // Array per memorizzare i colori

    // Ottieni l'asse y di sinistra
    const yAxis = chart.scales.y;

    if (!yAxis) {
      // Se non viene trovato l'asse y di sinistra, uscire dalla funzione
      return;
    }

    // Definisci i colori in base ai ticks dell'asse y di sinistra
    const { ticks } = yAxis;
    ticks.forEach((tick) => {
      const { value } = tick;
      if (value < -50) {
        colors.unshift('rgba(210, 25, 49, 0.1)'); // Rosso se il valore è inferiore a -50
      } else if (value >= -50 && value <= 0) {
        colors.unshift('rgba(251, 211, 132, 0.1)'); // Arancione se il valore è compreso tra -50 e 0
      } else if (value >= 0 && value < 50) {
        colors.unshift('rgba(2, 119, 166, 0.1)'); // Blu se il valore è compreso tra 0 e 50
      } else {
        colors.unshift('rgba(27, 125, 97, 0.1)'); // Verde se il valore è maggiore o uguale a 50
      }
    });

    const { chartArea } = chart;
    const rectangleHeight = chartArea.height / ticks.length;

    colors.forEach((color, index) => {
      ctx.fillStyle = color;
      ctx.fillRect(
        chartArea.left, chartArea.top + index * rectangleHeight, chartArea.right - chartArea.left, rectangleHeight,
      );
    });
  },
};
